<template>
  <div class="cases">
    <TabBar_m />
    <div class="banner"></div>
    <div class="cases_detail">
      <div class="title">
        <h6>Successful cases</h6>
        <i></i>
        <h3>成功案例</h3>
      </div>
      <!-- 成功案例 -->
      <ul class="cases_box">
        <li
          class="cases_item"
          v-for="(item,index) in casesList"
          :key="index"
          @click="ToDetail(item)"
        >
          <div class="cases_img">
            <img :src="item.imgurl" alt />
          </div>
          <div class="cases_txt">
            <div class="cases_icon">
              <img :src="item.iconurl" alt />
            </div>
            <h4>{{item.h4}}</h4>
            <p>{{item.p}}</p>
          </div>
        </li>
        <!-- <li class="cases_item">
          <div class="cases_img">
            <img src="../assets/image_m/cases_2.png" alt />
          </div>
          <div class="cases_txt">
            <div class="cases_icon">
              <img src="../assets/images/web_icon.png" alt />
            </div>
            <h4>公司官网</h4>
            <p>陕西远达智能科技有限公司是一家集行业解决方案、自主软硬件研发、万物物联系统集成与服务于一体的...</p>
          </div>
        </li>
        <div class="cases_item">
          <div class="cases_img">
            <img src="../assets/image_m/cases_3.png" alt />
          </div>
          <div class="cases_txt">
            <div class="cases_icon">
              <img src="../assets/images/hardware_icon.png" alt />
            </div>
            <h4>增氧机硬件设备</h4>
            <p>增氧机是一种常被应用于渔业养殖业的机器。它的主要作用是增加水中的氧气含量以确保水中的鱼类...</p>
          </div>
        </div>
        <div class="cases_item">
          <div class="cases_img">
            <img src="../assets/image_m/cases_4.png" alt />
          </div>
          <div class="cases_txt">
            <div class="cases_icon">
              <img src="../assets/images/iphone_icon.png" alt />
            </div>
            <h4>奥沙渔业</h4>
            <p>奥沙渔业主要是研发水产养殖方面的物联网，包括三层结构：分别是软件系统（移动APP）、数据分析...</p>
          </div>
        </div>
        <div class="cases_item">
          <div class="cases_img">
            <img src="../assets/image_m/cases_5.png" alt />
          </div>
          <div class="cases_txt">
            <div class="cases_icon">
              <img src="../assets/images/iphone_icon.png" alt />
            </div>
            <h4>一毛共享</h4>
            <p>一毛共享是一款集商业推广、网上购物于一体的，个性化电子海报智能分发平台。</p>
          </div>
        </div>
        <div class="cases_item">
          <div class="cases_img">
            <img src="../assets/image_m/cases_6.png" alt />
          </div>
          <div class="cases_txt">
            <div class="cases_icon">
              <img src="../assets/images/iphone_icon.png" alt />
            </div>
            <h4>良境</h4>
            <p>“良境”是良境（深圳）网络科技有限公司开发的一款通过构建美陈、景观、装饰、灯光、花艺的空间设计行...</p>
          </div>
        </div>
        <div class="cases_item">
          <div class="cases_img">
            <img src="../assets/image_m/cases_7.png" alt />
          </div>
          <div class="cases_txt">
            <div class="cases_icon">
              <img src="../assets/images/iphone_icon.png" alt />
            </div>
            <h4>万物物联</h4>
            <p>万物物联也称智慧物联，主要指的是为所有硬件的联网，提供一整套系统性的解决方案。</p>
          </div>
        </div>
        <div class="cases_item">
          <div class="cases_img">
            <img src="../assets/image_m/cases_8.png" alt />
          </div>
          <div class="cases_txt">
            <div class="cases_icon">
              <img src="../assets/images/iphone_icon.png" alt />
            </div>
            <h4>未来智能箱</h4>
            <p>未来智能箱是公司自主研发搭配智能模块，通过蓝牙通信技术、网路安全加密技术实现智能箱的定位功能...</p>
          </div>
        </div>
        <div class="cases_item">
          <div class="cases_img">
            <img src="../assets/image_m/cases_9.png" alt />
          </div>
          <div class="cases_txt">
            <div class="cases_icon">
              <img src="../assets/images/iphone_icon.png" alt />
            </div>
            <h4>赤商风采</h4>
            <p>为赤峰商会会员提供了信息交流的平台。每位注册用户可通过app设置自己旗下公司的信息，加入商会...</p>
          </div>
        </div>-->
      </ul>
    </div>
    <Footer_m />
  </div>
</template>

<script>
import Bus from "../Bus";
export default {
  components: {},
  props: {},
  data() {
    return {
      item: 1,
      casesList: [
        {
          id: 1,
          imgurl: require("@/assets/image_m/cases_1.png"),
          iconurl: require("@/assets/images/iphone_icon.png"),
          backgroundurl: require("@/assets/image_m/sale_banner.png"),
          bigbackgroundurl: require("@/assets/image_m/sale_detail.png"),
          h4: "销售大神",
          p:
            "销售大神是一款快速为企业匹配目标客户信息，建立快速沟通通道，实现企业快速成交的销售平台...",
          titleH6: "用户体验/移动平台开发",
          txtH5: "以快速成交为目的的销售神器",
          p1:
            "销售大神是一款快速为企业匹配目标客户信息，建立快速沟通通道，实现企业快速成交的销售平台，目前已覆盖全国1.5亿家企业信息，我们只有一个目标：让销售快速成交！",
          p2:
            "销售业绩是企业的命脉。不管你是虚拟的线上产品，还是实体线下产业，最终如何把产品市场化，锁定重点有效客户，达成交易，是每一个企业关注的。",
          p3:
            "天下武功，唯快不破。销售战略讲究抢占先机，精准把控市场。销售大神这款APP，重在“快速”俩字。快速匹配目标客户 → 快速建立沟通通道 → 快速抢占重点资源。",
          p4:
            "本着服务中小企业销售业绩快速增涨的研发初心，我们决定在未来3个月内，对新入驻的企业，免费送出1个月的VIP尊贵服务体验，现在注册，即可领取。",
        },
        {
          id: 2,
          imgurl: require("@/assets/image_m/cases_2.png"),
          iconurl: require("@/assets/images/web_icon.png"),
          backgroundurl: require("@/assets/image_m/sale_banner.png"),
          bigbackgroundurl: require("@/assets/image_m/sale_detail.png"),
          h4: "公司官网",
          p:
            "陕西远达智能科技有限公司是一家集行业解决方案、自主软硬件研发、万物物联系统集成与服务于一体的...",
          titleH6: "用户体验/移动平台开发",
          txtH5: "以快速成交为目的的销售神器",
          p1:
            "销售大神是一款快速为企业匹配目标客户信息，建立快速沟通通道，实现企业快速成交的销售平台，目前已覆盖全国1.5亿家企业信息，我们只有一个目标：让销售快速成交！",
          p2:
            "销售业绩是企业的命脉。不管你是虚拟的线上产品，还是实体线下产业，最终如何把产品市场化，锁定重点有效客户，达成交易，是每一个企业关注的。",
          p3:
            "天下武功，唯快不破。销售战略讲究抢占先机，精准把控市场。销售大神这款APP，重在“快速”俩字。快速匹配目标客户 → 快速建立沟通通道 → 快速抢占重点资源。",
          p4:
            "本着服务中小企业销售业绩快速增涨的研发初心，我们决定在未来3个月内，对新入驻的企业，免费送出1个月的VIP尊贵服务体验，现在注册，即可领取。",
        },
        {
          id: 3,
          imgurl: require("@/assets/image_m/cases_3.png"),
          iconurl: require("@/assets/images/hardware_icon.png"),
          backgroundurl: require("@/assets/image_m/sale_banner.png"),
          bigbackgroundurl: require("@/assets/image_m/sale_detail.png"),
          h4: "增氧机硬件设备",
          p:
            "增氧机是一种常被应用于渔业养殖业的机器。它的主要作用是增加水中的氧气含量以确保水中的鱼类...",
          titleH6: "用户体验/移动平台开发",
          txtH5: "以快速成交为目的的销售神器",
          p1:
            "销售大神是一款快速为企业匹配目标客户信息，建立快速沟通通道，实现企业快速成交的销售平台，目前已覆盖全国1.5亿家企业信息，我们只有一个目标：让销售快速成交！",
          p2:
            "销售业绩是企业的命脉。不管你是虚拟的线上产品，还是实体线下产业，最终如何把产品市场化，锁定重点有效客户，达成交易，是每一个企业关注的。",
          p3:
            "天下武功，唯快不破。销售战略讲究抢占先机，精准把控市场。销售大神这款APP，重在“快速”俩字。快速匹配目标客户 → 快速建立沟通通道 → 快速抢占重点资源。",
          p4:
            "本着服务中小企业销售业绩快速增涨的研发初心，我们决定在未来3个月内，对新入驻的企业，免费送出1个月的VIP尊贵服务体验，现在注册，即可领取。",
        },
        {
          id: 4,
          imgurl: require("@/assets/image_m/cases_4.png"),
          iconurl: require("@/assets/images/iphone_icon.png"),
          backgroundurl: require("@/assets/image_m/aosha_banner.png"),
          bigbackgroundurl: require("@/assets/image_m/aosha_detail.png"),
          h4: "奥沙渔业",
          p:
            "奥沙渔业主要是研发水产养殖方面的物联网，包括三层结构：分别是软件系统（移动APP）、数据分析...",
          titleH6: "用户体验/移动平台开发",
          txtH5: "智慧养殖系统，养殖业的好帮手",
          p1:
            "通过软件对奥莎渔业的增氧机进行购买或者租赁，购买租赁实现在线支付，并且租赁到期可实现在线缴费，同时可以查看增氧机相关的信息便于用户及时管理，也可通过APP对增氧机进行开关控制，同时可实现远程控制。",
          p2:
            "用“奥莎渔业”APP，科学养殖、智慧养殖、高产高效，好产品值得推广和宣传！养殖不用愁，供求关系系统自动建立，让你养殖的鱼及时找到客商收购，实现大丰收！",
        },
        {
          id: 5,
          imgurl: require("@/assets/image_m/cases_5.png"),
          iconurl: require("@/assets/images/iphone_icon.png"),
          backgroundurl: require("@/assets/image_m/yimao_banner.png"),
          bigbackgroundurl: require("@/assets/image_m/yimao_detail.png"),
          h4: "一毛共享",
          p:
            "一毛共享是一款集商业推广、网上购物于一体的，个性化电子海报智能分发平台。",
          titleH6: "用户体验/移动平台开发",
          txtH5: "广告赚钱平台，精准获取关注",
          p1:
            "一毛共享是一款集商业推广、网上购物于一体的，个性化电子海报智能分发平台。",
          p2:
            " 商家通过红包的形式投放自己的海报，让精准用户主动收藏广告，自动建立起商家自身的粉丝池，轻松实现持续性营销。商家按实际推广效果付费，不花冤枉钱，投放更为精准、有效，用户转化率高。",
          p3:
            "一毛共享还具有商城功能，商家不但可以做宣传，还能去销售和推广自己的商品和服务",
        },
        {
          id: 6,
          imgurl: require("@/assets/image_m/cases_6.png"),
          iconurl: require("@/assets/images/iphone_icon.png"),
          backgroundurl: require("@/assets/image_m/liangjing_banner.png"),
          bigbackgroundurl: require("@/assets/image_m/liangjing_detail.png"),
          h4: "良境",
          p:
            "“良境”是良境（深圳）网络科技有限公司开发的一款通过构建美陈、景观、装饰、灯光、花艺的空间设计行...",
          titleH6: "用户体验/移动平台开发",
          txtH5: "专注美陈定制",
          p1:
            "“良境”是一款通过构建美陈、景观、装饰、灯光、花艺的空间设计行业垂直生态平台，满足行业内人士、公司相互交流、学习、交易等需求的产品。",
        },
        {
          id: 7,
          imgurl: require("@/assets/image_m/cases_7.png"),
          iconurl: require("@/assets/images/iphone_icon.png"),
          backgroundurl: require("@/assets/image_m/wanwu_banner.png"),
          bigbackgroundurl: require("@/assets/image_m/wanwu_detail.png"),
          h4: "万物物联",
          p:
            "万物物联也称智慧物联，主要指的是为所有硬件的联网，提供一整套系统性的解决方案。",
          titleH6: "用户体验/移动平台开发",
          txtH5: "智慧家庭管理",
          p1:
            "万物物联就是为所有的硬件联网，将人，流程，数据和设备使用结合一起，使得物体不再冰冷，而是聪明的明白用户所需。确切来说，它不是一种产品，更是一种解决方案。",
          p2:
            "万物物联只要有信号，就能控制用电设备，就像微信聊天一样方便，再远都可以。无论是生活、工作、娱乐和旅行各种应用场景，只要搭载我们的万物物联解决方案，都能随心所欲地掌控。",
        },
        {
          id: 8,
          imgurl: require("@/assets/image_m/cases_8.png"),
          iconurl: require("@/assets/images/iphone_icon.png"),
          backgroundurl: require("@/assets/image_m/feture_banner.png"),
          bigbackgroundurl: require("@/assets/image_m/feture_detail.png"),
          h4: "未来智能箱",
          p:
            "未来智能箱是公司自主研发搭配智能模块，通过蓝牙通信技术、网路安全加密技术实现智能箱的定位功能...",
          titleH6: "用户体验/移动平台开发",
          txtH5: "一部手机就可以操作的智能箱",
          p1:
            "未来智能箱是公司自主研发搭配智能模块，通过蓝牙通信技术、网路安全加密技术实现智能箱的定位功能、开箱功能可联网集中管理智能箱，用户只需在app上扫一扫箱子的二维码，就可看到箱子的使用记录，通过蓝牙连接到设备之后就可进行开箱操作，保证产品的保真、溯源！",
        },
        {
          id: 9,
          imgurl: require("@/assets/image_m/cases_9.png"),
          iconurl: require("@/assets/images/iphone_icon.png"),
          backgroundurl: require("@/assets/image_m/chishang_banner.png"),
          bigbackgroundurl: require("@/assets/image_m/chishang_detail.png"),
          h4: "赤商风采",
          p:
            "为赤峰商会会员提供了信息交流的平台。每位注册用户可通过app设置自己旗下公司的信息，加入商会...",
          titleH6: "用户体验/移动平台开发",
          txtH5: "信息交流平台",
          p1:
            "为赤峰商会相关用户提供了信息交流的平台。每位注册用户可通过app设置自己旗下公司的信息，加入某个感兴趣的商会、收藏感兴趣的人，也可给自己设定个人风采。 app会通过定位信息显示当前城市中已加入商会的公司，可给对方打电话、留言。如遇商会用户违规，可对该用户进行举报，管理人员会给予适当的处理。 商会人员可通过信息汇板块发布供应和求购信息。",
        },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    ToDetail(item) {
      this.$router.push("/cases_detail-m");

      this.$nextTick(function () {
        //解决第一次监听不到数据
        Bus.$emit("listenToA", item);
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.banner {
  background: url("../assets/image_m/cases_banner.png") no-repeat;
  background-position: center;
  background-size: 100%;
  margin-top: 50px;
  &::before {
    content: "";
    display: block;
    padding-top: 100%;
  }
}
.cases_detail {
  .title {
    padding: 16px;
    h6 {
      line-height: 15px;
      font-size: 10px;
      text-transform: uppercase;
    }
    i {
      display: block;
      width: 30px;
      height: 2px;
      background: #26acff;
      margin: 4px 0;
    }
    h3 {
      line-height: 25px;
      font-size: 18px;
      margin-bottom: 12px;
    }
    p {
      text-indent: 2em;
      line-height: 21px;
      font-size: 15px;
    }
  }
  .cases_box {
    display: flex;
    flex-wrap: wrap;
    padding: 0 16px;
    justify-content: space-between;
    .cases_item {
      width: 49%;
      border: 1px solid #eaeaea;
      margin-bottom: 8px;
      .cases_txt {
        padding: 0 10px 12px 12px;
        .cases_icon {
          width: 30px;
          height: 30px;
          background: #26acff;
          border: 2px solid #ffffff;
          border-radius: 50%;
          transform: translateY(-50%);
          text-align: center;
          line-height: 30px;
          img {
            width: 13px;
            height: 16px;
          }
        }
        h4 {
          font-size: 14px;
          color: #404040;
          line-height: 13px;
          margin-bottom: 7px;
        }
        p {
          font-size: 12px;
          line-height: 16px;
        }
      }
      .cases_img {
        img {
          width: 100%;
        }
      }
    }
  }
}
@media (min-width: 750px) {
  .cases_detail .cases_box {
    .cases_item {
      width: 32%;
    }
  }
}
</style>